var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1678 0.583984H4.91782C2.57699 0.583984 0.75 2.43952 0.75 4.75181V11.8314C0.75 12.3167 1.14965 12.7163 1.63495 12.7163H13.0822C15.423 12.7163 17.25 10.8608 17.25 8.54852V4.75181C17.2215 2.43952 15.3945 0.583984 13.1678 0.583984ZM10.1419 9.40492H4.11851C3.63322 9.40492 3.34775 9.00527 3.34775 8.63416C3.34775 8.26305 3.74741 7.8634 4.11851 7.8634H10.1419C10.6272 7.8634 10.9126 8.26305 10.9126 8.63416C10.9126 9.00527 10.6272 9.40492 10.1419 9.40492ZM13.8244 5.52257H4.11851C3.63322 5.52257 3.34775 5.12291 3.34775 4.75181C3.34775 4.26651 3.74741 3.98104 4.11851 3.98104H13.8244C14.3097 3.98104 14.5952 4.3807 14.5952 4.75181C14.5952 5.12291 14.224 5.52257 13.8244 5.52257Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.389cd4b9c1d055a18e534a5786db72b6.svg";
export { ForwardRef as ReactComponent };